import TramoEdadConfig from "./TramoEdadConfig.jsx";
import MontoTasaConfig from "./MontoTasaConfig.jsx";
import PrecioAtributosConfig from "./PrecioAtributosConfig.jsx";
import FijoConfig from "./FijoConfig.jsx";
import PorMascotaConfig from "./PorMascotaConfig.jsx";
import PrecioCantidadConfig from "./PrecioCantidadConfig.jsx";
import { supportsCargas } from "./calculatorConfigSchema.js";

export const CALCULATOR_TYPES = [
  {
    value: "tramo_edad",
    label: "Tramo por edad",
    descripcion: "Prima según la edad del asegurado (tabla precios_base).",
    Component: TramoEdadConfig,
    comoConfigurar: [
      "En el tab \"Precios Base (UF)\" carga una fila por rango de edad (edad mínima/máxima) con su precio en UF para este plan.",
      "Si el precio depende de la actividad/riesgo del asegurado, activa \"Factor por actividad\".",
      "Si el plan cubre grupo familiar, activa \"Aplica cargas familiares\" y elige el modelo (descuento sobre titular o precio por carga).",
      "Ejemplo: 18–30 años → 0,5 UF; 31–45 → 0,8 UF; 46–60 → 1,2 UF.",
    ],
  },
  {
    value: "monto_tasa",
    label: "Monto × tasa",
    descripcion: "Prima = monto asegurado × tasa.",
    Component: MontoTasaConfig,
    comoConfigurar: [
      "Elige el origen del monto asegurado: \"Lo ingresa el cliente al cotizar\" (request, ej. el valor de la bicicleta), \"Del plan\" (indica el campo, ej. capital_uf) o \"Valor fijo\" (escribe el monto).",
      "Carga la tabla de tasas con la tasa que aplica a este plan.",
      "La prima se calcula como monto asegurado × tasa.",
      "Ejemplo: monto 1.000 UF × tasa 0,002 = 2 UF de prima.",
    ],
  },
  {
    value: "construccion_comuna",
    label: "Precio por atributos (comuna)",
    descripcion: "Precio según atributos como comuna o construcción.",
    Component: PrecioAtributosConfig,
    comoConfigurar: [
      "Agrega los atributos que hacen variar el precio (ej. comuna, tipo de construcción) con su operador: \"Igual\" (eq) o \"Contiene\" (array_contains).",
      "En \"Precios Base (UF)\" carga una fila por combinación de atributos con su precio en UF.",
      "Si el plan cubre grupo familiar, activa \"Aplica cargas familiares\".",
      "Ejemplo: comuna=Providencia → 1,2 UF; comuna=Maipú → 0,9 UF.",
    ],
  },
  {
    value: "precio_base_atributos",
    label: "Precio por atributos (genérico)",
    descripcion: "Precio según atributos arbitrarios del asegurado.",
    Component: PrecioAtributosConfig,
    comoConfigurar: [
      "Agrega los atributos que discriminan el precio (los que apliquen a este plan) con su operador: \"Igual\" (eq) o \"Contiene\" (array_contains).",
      "En \"Precios Base (UF)\" carga una fila por combinación de atributos con su precio en UF.",
      "Si el plan cubre grupo familiar, activa \"Aplica cargas familiares\".",
      "Ejemplo: especialidad=dental → 0,4 UF; especialidad=oftalmología → 0,6 UF.",
    ],
  },
  {
    value: "fijo",
    label: "Precio fijo",
    descripcion: "Prima fija única del plan.",
    Component: FijoConfig,
    comoConfigurar: [
      "En el tab \"Precios Base (UF)\" carga una única fila para este plan (plan_id + Activo) con el precio en UF.",
      "No requiere más parámetros: la prima es siempre ese precio.",
      "Ejemplo: plan Hogar Básico → 0,7 UF fijo.",
    ],
  },
  {
    value: "por_mascota",
    label: "Por mascota",
    descripcion: "Precio unitario × número de mascotas.",
    Component: PorMascotaConfig,
    comoConfigurar: [
      "En el tab \"Precios Base (UF)\" carga el precio unitario por mascota (una fila, plan_id + Activo).",
      "En el tab \"Configuración JSON\" activa el campo numero_mascotas para que el cotizador pregunte la cantidad.",
      "La prima se calcula como precio unitario × número de mascotas.",
      "Ejemplo: 0,3 UF por mascota × 2 mascotas = 0,6 UF.",
    ],
  },
  {
    value: "precio_cantidad",
    label: "Precio × cantidad (p × q)",
    descripcion: "Precio unitario del plan × la cantidad que ingresa el cliente (unidad configurable).",
    Component: PrecioCantidadConfig,
    comoConfigurar: [
      "En el tab \"Precios Base (UF)\" carga UNA fila para este plan (plan_id + Activo) con el precio de UNA unidad en UF.",
      "Escribe el nombre del atributo de cantidad (ej. cantidad_guardias): con ese nombre viaja la cantidad al calculator y así la manda el miniform.",
      "Define el máximo por cotización para que un cero de más no genere una prima absurda pero cobrable.",
      "Opcional: escribe cómo se llama la unidad (singular/plural) para el copy del cotizador; si lo dejas vacío flow lo deriva del nombre del atributo.",
      "Asigna el \"MiniForm Precio × Cantidad\" más abajo: es el único que pide solo la cantidad.",
      "Si cada unidad necesita datos propios (RUT, nombre), agrega el módulo \"Asegurados\" (id nominados) en modulos_requeridos — no se configura en este tipo de cálculo.",
      "Ejemplo: 0,35 UF por guardia × 4 guardias = 1,40 UF.",
    ],
  },
].map((t) => ({ ...t, supportsCargas: supportsCargas(t.value) }));

export function getCalculatorType(value) {
  return CALCULATOR_TYPES.find((t) => t.value === value) || null;
}
